export default __webpack_public_path__ + "static/media/TV_Serra_Dourada.3c3141f8.png";